import React    from 'react';
import TextField     from '@material-ui/core/TextField';
import SearchIcon    from '@material-ui/icons/SearchOutlined';
import { Observe }   from 'rewire-core';
import { pageState } from './DefaultSettingsView';
import SettingsModel, { useWatch } from './SettingsModel';

function handleKeyDown(evt: React.KeyboardEvent<HTMLDivElement>) {
  if (evt.key === 'Enter') {
    const settings = pageState.__settings as SettingsModel;
    settings.paging.search = (evt.target as any).value;
  }
}

export default function SettingsSearch(_props: any) {
  const [text, setText] = React.useState<string>((pageState.__settings as SettingsModel)?.paging?.search ?? '');
  useWatch(() => pageState.__settings, () => requestAnimationFrame(() => setText((pageState.__settings as SettingsModel)?.paging?.search ?? '')));
  return (
    <Observe render={() => (
      <TextField variant="standard" placeholder="search" value={text} onKeyDown={handleKeyDown} onChange={(v) => setText(v.target.value)} InputProps={{startAdornment: (<SearchIcon />)}}
      />
    )}/>
  );
}
